import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { SVG_ICONS } from '@core/data/custom-svg-icon.data';
import { MESSAGE_TYPE } from '@shared/models/message.model';
import { RouterService } from '@core/services/router.service';
import { GlobalService } from '@core/services/global.service';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2';
import { AppConstant } from '@app/app.constant';
import { SEOService } from '@core/services/seo.service';
import { Settings } from 'luxon';
import { GrecaptchaService } from '@shared/grecaptcha';
import { ThemeService } from '@core/services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    loading = false;
    timezone = AppConstant.DEFAULT_TIMEZONE;

    constructor(
        private angulartics: Angulartics2GoogleGlobalSiteTag,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private globalService: GlobalService,
        private routerService: RouterService,
        private seoService: SEOService,
        private titleService: Title,
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
        private grecaptchaService: GrecaptchaService,
        private themeService: ThemeService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.grecaptchaService.embeddedScript();
        this.angulartics.startTracking();
        // the lang to use, if the lang isn't available, it will use the current loader to get them

        this.addIcons();
        if (!AppConstant.APP_PRODUCTION) {
            this.titleService.setTitle('SuperAdmin [' + AppConstant.APP_ID.toUpperCase() + ']');
        }
        // set default timezone
        if (this.timezone) {
            this.setTimezone(this.timezone);
        }
    }

    ngOnInit(): void {
        this.themeService.initialize();

        this.globalService.message.subscribe(message => {
            let msg = '';
            if (message.message) {
                msg = this.translateService.instant(message.message);
            }
            switch (message.type) {
                case MESSAGE_TYPE.error: {
                    this.toastrService.error(msg, message.title, {
                        positionClass: 'toast-bottom-right',
                        enableHtml: true,
                    });
                    break;
                }
                case MESSAGE_TYPE.success: {
                    this.toastrService.success(msg, message.title, {
                        positionClass: 'toast-success-custom'
                    });
                    break;
                }
                case MESSAGE_TYPE.warning: {
                    this.toastrService.warning(msg, message.title, {
                        positionClass: 'toast-bottom-right'
                    });
                    break;
                }
                case MESSAGE_TYPE.info: {
                    this.toastrService.info(msg, message.title, {
                        positionClass: 'toast-bottom-right'
                    });
                    break;
                }
                default:
                    this.toastrService.show(msg, message.title, {
                        positionClass: 'toast-bottom-right'
                    });
            }
        });
        this.globalService.loader.status.subscribe(status => {
            this.loading = status;
            this.changeDetectorRef.detectChanges();
        });

        this.routerService.loadRouting();
        this.seoService.listenRouterChange();
    }

    addIcons() {
        SVG_ICONS.forEach(item => {
            this.iconRegistry.addSvgIcon(
                item.key,
                this.sanitizer.bypassSecurityTrustResourceUrl(item.path)
            );
        });
    }


    setTimezone(timezone: string) {
        Settings.defaultZone = timezone;
    }
}
